<template>
    <div>
        <div class="vx-row mt-3">
            <div class="vx-col w-full mb-base">
                <Table 
                    :draw="draw" 
                    :status="activeTab" 
                    :warehouseId="this.warehouseId"
                    :supplierId="this.supplierId">
                </Table>
            </div>
        </div>
    </div>
</template>
<script>

import Date from "@/components/Date.vue";
import Table from "./component/Table.vue";
import Currency from "@/components/Currency.vue";

export default {
    components: {
        Currency,
        Date,
        Table
    },
    props: {
        filterData: {
            type: Object,
            default: () => ({})
        },
        draw: {
            type: Number,
        },
    },
    data() {
        return {
            activeTab: "Released",
            warehouseId: null,
            supplierId: null,
        }
    },
    methods: {
        fetchDataWithFilters(filter) {
            this.draw = filter.draw
            this.supplierId = filter.supplierId
            this.warehouseId = filter.warehouseId
        },
    },
    mounted(){
        this.draw = this.filterData.draw
        this.supplierId = this.filterData.supplierId
        this.warehouseId = this.filterData.warehouseId
        sessionStorage.setItem('activeTabDBP', "1");
    },
    watch: {
        filterData: {
            handler(newVal, oldVal) {                
                this.fetchDataWithFilters(newVal);
            },
            deep: true
        }
    },
}
</script>